// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"679":"86f45791","803":"f9d47aa9","2241":"86f45791","3024":"86f45791","5782":"25bc085e"}[chunkId] + ".chunk.css";
};